import { render, staticRenderFns } from "./costTotal.vue?vue&type=template&id=4324c3a2&scoped=true&"
import script from "./costTotal.vue?vue&type=script&lang=js&"
export * from "./costTotal.vue?vue&type=script&lang=js&"
import style0 from "./costTotal.vue?vue&type=style&index=0&id=4324c3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324c3a2",
  null
  
)

export default component.exports